import { createFileRoute } from "@tanstack/react-router";
import { CompetenceContainer } from "../../app/views/competence/competenceContainer";

export const Route = createFileRoute("/competence")({
  component: CompetenceContainer,
});
